// import React, { memo, useEffect, useRef, useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faGear,
//   faSliders,
//   faFilter,
//   faFilterCircleXmark,
// } from "@fortawesome/free-solid-svg-icons";
// type Props = {
//   enableImage: (imgSrc: string) => Promise<void>;
//   enableBlur: () => Promise<void>;
//   disableVirtualBackground: () => Promise<void>;
// };

// // Define types
// type BackgroundType = "none" | "blur" | "office" | "beach" | "nature" | "space";

// interface BackgroundOption {
//   id: BackgroundType;
//   name: string;
//   icon: string;
//   imageUrl?: string;
// }
// const SettingBG = (props: Props) => {
//   // State
//   const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
//   const [activeBackground, setActiveBackground] =
//     useState<BackgroundType>("none");

//   // Refs
//   const dropdownRef = useRef<HTMLDivElement>(null);
//   const toggleButtonRef = useRef<HTMLButtonElement>(null);

//   // Virtual Backgrounds data
//   const virtualBackgrounds: BackgroundOption[] = [
//     {
//       id: "office",
//       name: "Office",
//       icon: "fas fa-building",
//       imageUrl: "/Bg1.jpg",
//     },
//     {
//       id: "beach",
//       name: "Beach",
//       icon: "fas fa-umbrella-beach",
//       imageUrl: "Bg2.jpg",
//     },
//     {
//       id: "nature",
//       name: "Nature",
//       icon: "fas fa-tree",
//       imageUrl: "Bg3.jpg",
//     },
//     {
//       id: "space",
//       name: "Space",
//       icon: "fas fa-rocket",
//       imageUrl: "Bg4.jpg",
//     },
//   ];

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (
//         dropdownRef.current &&
//         !dropdownRef.current.contains(event.target as Node) &&
//         toggleButtonRef.current &&
//         !toggleButtonRef.current.contains(event.target as Node)
//       ) {
//         setIsDropdownOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Handlers
//   const handleToggleDropdown = (): void => {
//     setIsDropdownOpen(!isDropdownOpen);
//   };

//   const handleBackgroundSelect = (backgroundId: BackgroundType): void => {
//     setActiveBackground(backgroundId);
//     setIsDropdownOpen(false);
//   };
//   return (
//     <div className="video-settings-controls">
//       <button
//         ref={toggleButtonRef}
//         className="control-btn"
//         onClick={handleToggleDropdown}
//         title="Background Settings"
//         aria-expanded={isDropdownOpen}
//       >
//         <FontAwesomeIcon icon={faGear} />
//       </button>

//       <div
//         ref={dropdownRef}
//         className={`dropdown-menu ${isDropdownOpen ? "active" : ""}`}
//       >
//         {/* Blur Background Option */}
//         <div
//           className={`menu-item ${activeBackground === "blur" ? "active" : ""}`}
//           onClick={() => {
//             handleBackgroundSelect("blur");
//             props.enableBlur();
//           }}
//         >
//           <FontAwesomeIcon icon={faSliders} />
//           <span>Blur Background</span>
//         </div>

//         {/* Remove Filters Option */}
//         {activeBackground !== "none" && (
//           <div
//             className="menu-item"
//             onClick={() => {
//               handleBackgroundSelect("none");
//               props.disableVirtualBackground();
//             }}
//           >
//             <FontAwesomeIcon icon={faFilterCircleXmark} />
//             <span>Remove Filters</span>
//           </div>
//         )}

//         {/* Virtual Backgrounds Section */}
//         <div className="background-images-section">
//           <h4>Virtual Backgrounds</h4>
//           <div className="background-grid">
//             {virtualBackgrounds.map((background) => (
//               <div
//                 key={background.id}
//                 className={`bg-option ${
//                   activeBackground === background.id ? "active" : ""
//                 }`}
//                 onClick={() => {
//                   handleBackgroundSelect(background.id);
//                   props.enableImage(background.imageUrl!);
//                 }}
//                 title={background.name}
//               >
//                 <img src={background.imageUrl} alt={background.name} />
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default memo(SettingBG);



import React, { memo, useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGear,
  faSliders,
  faFilterCircleXmark,
} from "@fortawesome/free-solid-svg-icons";

type Props = {
  enableImage: (imgSrc: string) => Promise<void>;
  enableBlur: () => Promise<void>;
  disableVirtualBackground: () => Promise<void>;
};

// Background types
type BackgroundType = "none" | "blur" | "office" | "beach" | "nature" | "space";

interface BackgroundOption {
  id: BackgroundType;
  name: string;
  imageUrl: string;
}

const virtualBackgrounds: BackgroundOption[] = [
  { id: "office", name: "Office", imageUrl: "/Bg1.jpg" },
  { id: "beach", name: "Beach", imageUrl: "/Bg2.jpg" },
  { id: "nature", name: "Nature", imageUrl: "/Bg3.jpg" },
  { id: "space", name: "Space", imageUrl: "/Bg4.jpg" },
];

const SettingBG = ({ enableImage, enableBlur, disableVirtualBackground }: Props) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [activeBackground, setActiveBackground] = useState<BackgroundType>("none");

  const dropdownRef = useRef<HTMLDivElement>(null);
  const toggleButtonRef = useRef<HTMLButtonElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        toggleButtonRef.current &&
        !toggleButtonRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Background selection logic
  const handleBackgroundSelect = async (backgroundId: BackgroundType, imgUrl?: string) => {
    setActiveBackground(backgroundId);
    setIsDropdownOpen(false);

    if (backgroundId === "blur") {
      await enableBlur();
    } else if (backgroundId === "none") {
      await disableVirtualBackground();
    } else if (imgUrl) {
      await enableImage(imgUrl);
    }
  };

  return (
    <div className="video-settings-controls">
      {/* Settings button */}
      <button
        ref={toggleButtonRef}
        className="control-btn"
        onClick={() => setIsDropdownOpen((prev) => !prev)}
        title="Background Settings"
        aria-expanded={isDropdownOpen}
      >
        <FontAwesomeIcon icon={faGear} />
      </button>

      {/* Dropdown menu */}
      <div ref={dropdownRef} className={`dropdown-menu ${isDropdownOpen ? "active" : ""}`}>
        {/* Blur Background Option */}
        <div
          className={`menu-item ${activeBackground === "blur" ? "active" : ""}`}
          onClick={() => handleBackgroundSelect("blur")}
        >
          <FontAwesomeIcon icon={faSliders} />
          <span>Blur Background</span>
        </div>

        {/* Remove Filters Option */}
        {activeBackground !== "none" && (
          <div className="menu-item" onClick={() => handleBackgroundSelect("none")}>
            <FontAwesomeIcon icon={faFilterCircleXmark} />
            <span>Remove Filters</span>
          </div>
        )}

        {/* Virtual Backgrounds Section */}
        <div className="background-images-section">
          <h4>Virtual Backgrounds</h4>
          <div className="background-grid">
            {virtualBackgrounds.map((bg) => (
              <div
                key={bg.id}
                className={`bg-option ${activeBackground === bg.id ? "active" : ""}`}
                onClick={() => handleBackgroundSelect(bg.id, bg.imageUrl)}
                title={bg.name}
              >
                <img src={bg.imageUrl} alt={bg.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(SettingBG);
